import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);
  const [needsProfile, setNeedsProfile] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [emailHint, setEmailHint] = useState("");
  const [nickname, setNickname] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sid = match[1];
    setSessionId(sid);
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sid });
        if (data.needs_profile) {
          setNeedsProfile(true);
          setEmailHint(data.email || "");
          setLoading(false);
          return;
        }
        setUser(data.user);
        toast.success("Conectado com Google!");
        window.history.replaceState({}, document.title, "/");
        nav("/", { replace: true });
      } catch (e) {
        toast.error("Falha ao autenticar.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  const complete = async (e) => {
    e.preventDefault();
    if (!accept) { toast.error("Aceite os Termos e a Política de Privacidade."); return; }
    try {
      const { data } = await api.post("/auth/emergent-session", {
        session_id: sessionId, nickname, birthdate, accept_terms: accept,
      });
      setUser(data.user);
      toast.success("Conta criada!");
      window.history.replaceState({}, document.title, "/");
      nav("/", { replace: true });
    } catch (err) {
      toast.error("Não foi possível completar o cadastro.");
    }
  };

  if (needsProfile) {
    return (
      <div className="min-h-screen flex flex-col px-6 py-10 max-w-md mx-auto">
        <h1 className="text-3xl heading font-extrabold mt-4">Quase lá, {emailHint}</h1>
        <p className="text-muted-foreground mt-2 mb-6">Precisamos de só mais alguns dados.</p>
        <form onSubmit={complete} className="space-y-4">
          <input className="w-full h-12 px-4 rounded-lg bg-input border border-border" placeholder="Apelido" required minLength={2} value={nickname} onChange={(e)=>setNickname(e.target.value)} data-testid="google-complete-nickname" />
          <input type="date" className="w-full h-12 px-4 rounded-lg bg-input border border-border" required value={birthdate} onChange={(e)=>setBirthdate(e.target.value)} data-testid="google-complete-birthdate" />
          <label className="flex items-start gap-3 text-sm text-muted-foreground">
            <input type="checkbox" checked={accept} onChange={(e)=>setAccept(e.target.checked)} data-testid="google-complete-accept" />
            Li e aceito os Termos e a Política de Privacidade.
          </label>
          <button className="w-full h-12 bg-primary text-primary-foreground rounded-lg font-semibold press" data-testid="google-complete-submit">Entrar no Enkosta</button>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">Autenticando...</p>
    </div>
  );
}
